export enum ApiUserRole  {
     // Pour le moment on gère par rôle imbriqués en utilisant des demi-octets (4 bits) pour chaque rôle de manière à pouvoir
     // granulariser les permissions par la suite
     // bits 0..3	--> persimmsions de lecture (non granularisées)
     // bits 4..7	--> persimmsions opérateur (non granularisées)
     // bits 8..11	--> persimmsions d'administration (non granularisées)
     // bits 12..15	--> persimmsions root (non granularisées)
     // Les rôles
     CentralWeb		= "CentralWeb",     //2 << 16 -1,	// Pour le cas où on ajoute des permissions: (1111 1111) (1111 1111) -> octet 1 = permissions admin / octet 0 = permissions opérateur
     Admin			= "Admin",          //2 << 12 -1,		// 0000 1111 1111 1111
     Operator		     = "Operator"/*,       //2 <<  8 -1,	// 0000 0000 1111 1111
     Reader			= "Reader"          //2 <<  4 -1,		// 0000 0000 0000 1111*/
}